import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const getPointsThunk = createAsyncThunk(
    `GetPointsSlicer/getPointsThunk`,
    async ({ participantId, login } = {}, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const resolvedParticipantId = participantId || user.profile['custom:participant_id'];

        const url = participantId
            ? `Participant/${resolvedParticipantId}/balance/${login}`
            : `Participant/balance`;

        const { data } = await conciergeApiClient.get(url, { headers });

        return data;
    }
);

const initialState = {
    dataGetPoints: 0,
    loadingGetPoints: false,
    errorGetPoints: false,
};

const GetPointsSlicer = createSlice({
    name: 'GetPoints',
    initialState,
    reducers: {
        resetDataGetPoints: (state) => {
            state.dataGetPoints = 0;
            state.loadingGetPoints = false;
            state.errorGetPoints = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getPointsThunk.pending, (state) => {
            state.dataGetPoints = 0;
            state.loadingGetPoints = true;
            state.errorGetPoints = false;
        });
        builder.addCase(getPointsThunk.fulfilled, (state, action) => {
            state.dataGetPoints = action.payload;
            state.loadingGetPoints = false;
            state.errorGetPoints = false;
        });
        builder.addCase(getPointsThunk.rejected, (state) => {
            state.dataGetPoints = 0;
            state.loadingGetPoints = false;
            state.errorGetPoints = true;
        });
    },
});

export const { resetDataGetPoints } = GetPointsSlicer.actions;
export default GetPointsSlicer.reducer;